<template>
  <!--关于我们开始-->
  <div class="main-AboutUs backdrop" id="main-AboutUs">
    <div class="introduce">
      <div>
        <img src="../assets/img/pic/pic_about_img.jpg"/>
      </div>
      <div>
        <p v-for="obj in $t('introduce')">
								<span>
									&nbsp; &nbsp; &nbsp; &nbsp;{{obj}}
								</span>
        </p>
      </div>
    </div>
  </div>
  <!--关于我们结束-->
</template>

<script>
  export default {
    name: "us_intro",
    data() {
      return {
      }
    }
  }
</script>

<style scoped>
  .backdrop{
    padding: 0;
  }
  .title_content{
    color: rgb(255, 255, 0);
    font-size: .5rem;
    text-align: center;
  }
  .title_content span{
    font-size: .2rem;
    color: #fff;
  }
  /*关于我们开始*/
  .main-AboutUs{
    background-image: url(../assets/img/pic/pic_ABOUT.jpg);
    background-repeat:no-repeat;
  }
  .main-AboutUs .introduce{
    display: flex;
    flex-wrap:wrap;
    margin: 0.3rem 0.7rem 0 0.7rem;
    /*animation: 2s aircraft;*/
  }
  .main-AboutUs .introduce>div{
    width: 385px;
    flex-grow: 1;
    align-self:center;
  }
  .main-AboutUs .introduce>div span{
    font-size: 19px;
  }
  .main-AboutUs .introduce>div:first-of-type{
    text-align: center;
  }
  .main-AboutUs .introduce img{
    width: 80%;
  }
  .main-AboutUs .introduce span{
    font-family: 微软雅黑;
    font-size: 14px;
    line-height: 200%;
    color: #5a5a5a;
  }
  /*关于我们结束*/

  /*新闻动态结束*/
  @media screen and (max-width: 1024px) {

    .title_content{
      font-size: 1rem;

    }
  }
  @media screen and (max-width:768px){

    .title_content span{
      font-size: 12px;
    }
    .main-AboutUs .introduce>div span{
      font-size: 16px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/us_intro.vue